<template>
	<div class="flex flex-col min-h-screen">
		<OrganismHeaderBar
			:menu-social-items="menuSocialItems"
			:menu-service-items="menuServiceItems"
			:menu-items="mainMenuItems()"
			:phone-number="baseCompanyData.phoneNumber"
			:phone-link="phoneLink"
			:home-link="homeLink"
			:is-sales-header="isSales"
			@click-menu-button="openMobileMenu"
			@click-appointment-button="openAppointmentDialog"
		/>

		<main class="template-base-slot grow flex flex-col">
			<slot />
		</main>
		<OrganismFooter
			:links="footerMenuItems()"
			:company-data="{
				...fysioCompanyData,
				...baseCompanyData,
			}"
			:phone-link="phoneLink"
			@open-appointment-dialog="openAppointmentDialog"
		/>
		<AtomWhatsappButton class="fixed bottom-8 right-8" />
	</div>
	<OrganismDialogs />
	<OrganismNotifications />
</template>

<script lang="ts" setup>
import * as fysioCompanyData from '#fysio/core/consts/companyData';
import * as baseCompanyData from '#base/core/consts/companyData';
import menuSocialItems from '#fysio/core/consts/menuSocialItems';
import menuServiceItems from '#fysio/core/consts/menuServiceItems';
import { homeLink, phoneLink } from '#fysio/core/consts/links';

defineProps<{
	pageTitle?: string;
	isSales?: boolean;
}>();

useExternalScripts();

const {
	openAppointmentDialog,
	openMobileMenu,
	isDialogOpen,
	isDialogBottom,
} = useDialogs();

useHead({
	bodyAttrs: {
		class: computed(() => {
			return isDialogOpen.value && !isDialogBottom.value ? 'overflow-hidden' : '';
		}),
	},
});
</script>
